// Who on the VERANeural team has VERA Studio open. The team's Studio checks in about once a minute while it is open and
// signed in; the server keeps only the name and the time, never a customer's people, and only the founder and
// executives can read the list (online now, or last seen).
import { cpFetch } from "./controlPlane";

type Token = () => Promise<string | null>;
export type PresencePerson = { name: string; lastSeen: string; online: boolean };

/** The team's roles in Studio. Anyone who also holds a customer's role is that customer's person and isn't checked in. */
const TEAM_ROLES = ["Studio.Founder", "Studio.Executive", "Studio.Operations", "Studio.Psychologist", "Studio.Engineering", "Studio.Security"];

export const isTeam = (roles: string[]) => !roles.some((r) => r.startsWith("Studio.Client.")) && roles.some((r) => TEAM_ROLES.includes(r));
/** Who sees the list: the founder and executives (the server decides; this only saves a request). */
export const seesPresence = (roles: string[]) => isTeam(roles) && roles.some((r) => r === "Studio.Founder" || r === "Studio.Executive");

export const presence = {
  checkIn: (t: Token) => cpFetch<void>(t, "/v1/me/presence", { method: "POST" }),
  list: (t: Token) => cpFetch<{ people: PresencePerson[] }>(t, "/v1/hq/presence").then((r) => r.people ?? []),
};

/** "just now", "12 min ago", "3 h ago", "yesterday", or the date. */
export function lastSeenText(iso: string, now = Date.now()): string {
  const at = Date.parse(iso);
  if (!Number.isFinite(at)) return "";
  const min = Math.max(0, Math.round((now - at) / 60000));
  if (min < 2) return "just now";
  if (min < 60) return `${min} min ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h} h ago`;
  if (h < 48) return "yesterday";
  return new Date(at).toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
